var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.rootClass},[_c('div',{class:_vm.overlayClass,on:{"click":_vm.closeModal}}),_c('div',{class:_vm.containerClass},[_c('div',{class:_vm.contentClass},[_vm._t("default")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }